export default {
  title: 'Dados do Cliente'
}